import { render, staticRenderFns } from "./LoginWithBazaarIcon.vue?vue&type=template&id=08e8f9af"
import script from "./LoginWithBazaarIcon.vue?vue&type=script&lang=js"
export * from "./LoginWithBazaarIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports